import CardDetails from '../views/CardDetails';
import Library from '../views/Library';

const router = [
  {
    path: '/library',
    redirect: () => ('/library/custom-cards'),
  },
  {
    path: '/library/store-cards',
    redirect: () => ('/library/custom-cards'),
  },
  {
    name: 'library.library',
    path: '/library/:card_type',
    component: Library,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
  {
    name: 'library.cardDetails',
    path: '/library/:card_type/:card_id',
    component: CardDetails,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/library/router/index.js